import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import VirtualGiftList from 'components/virtualgift/VirtualGiftList';
import ModalViewVirtualGift from 'components/modals/ModalViewVirtualGift';

import {t} from 'l10n';

import paths from 'paths';

import 'sass/member/MemberVirtualGiftsBlock.scss';
import isMobile from "ismobilejs";

class MemberVirtualGiftsBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            openedVirtualGift: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.openedVirtualGift) {
            this.setState({
                openedVirtualGift: nextProps.virtualGifts.list.filter((item) => item.id === this.state.openedVirtualGift.id)[0]
            })
        }
    }

    render() {
        let {virtualGifts, match} = this.props,
            {list, totalCount} = virtualGifts;

        return (
            <aside className="gifts-member">
                <div className="content">
                    <div className="heading">
                        <h2>{t('My virtual gifts')} <em>{totalCount}</em></h2>
                        {list.length && !isMobile.any ? <Link to={paths.memberVirtualGifts.path} className="list-item">{t('All my virtual gifts')}</Link> : null}

                    </div>

                    <ModalViewVirtualGift
                        show={this.state.showModal}
                        closeFn={() => this.setState({showModal: false})}
                        virtualGift={this.state.openedVirtualGift}
                    />
                    <VirtualGiftList
                        virtualGifts={list}
                        openFn={(virtualGift) => this.setState({showModal: true, openedVirtualGift: virtualGift})}
                        actions
                    />

                    {(list.length && isMobile.any) ? <Link to={paths.memberVirtualGifts.path} className="get-all-gifts">{t('All my virtual gifts')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default MemberVirtualGiftsBlock;


// WEBPACK FOOTER //
// ./src/components/member/MemberVirtualGiftsBlock.js